import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiMail } from 'react-icons/fi';
import { useTheme } from '../contexts/ThemeContext';
import { THEMES, THEME_COLORS } from '../components/Constants';
import { authFetch } from '../utils/api';

export default function ForgotPasswordPage() {
    const { currentTheme } = useTheme();
    const themeColors = THEME_COLORS[currentTheme] || THEME_COLORS[THEMES.BLUE];

    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        setIsLoading(true);

        try {
            const response = await authFetch.post("/forgot-password", email);

            const data = await response.json();
            
            if (response.ok) {
                setSuccess(data.message); // Affiche le message de succès générique
            } else {
                 // Si la réponse n'est pas OK (400, 500, etc.), le message n'est pas générique.
                setError(data.error || "Erreur lors de la demande de réinitialisation.");
            }

        } catch (err) {
            console.error("❌ Erreur réseau:", err);
            setError("Impossible de contacter le serveur.");
        } finally {
            setIsLoading(false);
        }
    };

    const styles = {
        container: {
            display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", padding: "0 15px", boxSizing: "border-box",
        },
        card: {
            padding: 30, borderRadius: 20, boxShadow: "0 4px 15px rgba(0,0,0,0.15)", width: "100%", maxWidth: 400, boxSizing: "border-box", backgroundColor: themeColors.mainBackground,
        },
        title: { color: themeColors.secondary, textAlign: "center", marginBottom: 20 },
        input: { padding: "12px 12px 12px 40px", width: "100%", borderRadius: 10, border: `1px solid ${themeColors.inputBorder}`, boxSizing: "border-box" },
        button: { width: "100%", padding: 12, marginTop: 15, backgroundColor: themeColors.secondary, color: "#fff", border: "none", borderRadius: 10, cursor: "pointer", fontWeight: 'bold' },
        inputIcon: { position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: themeColors.secondary, fontSize: '18px' },
        inputWrapper: { position: "relative", marginBottom: 15 },
        link: { color: themeColors.secondary, textDecoration: 'none', fontWeight: 'bold' }
    };

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <h2 style={styles.title}>Mot de passe oublié</h2>
                <p style={{ color: themeColors.text, textAlign: 'center', marginBottom: 20 }}>
                    Veuillez entrer votre adresse e-mail. Nous vous enverrons un lien pour réinitialiser votre mot de passe.
                </p>
                <form onSubmit={handleSubmit}>
                    <div style={styles.inputWrapper}>
                        <FiMail style={styles.inputIcon} />
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            style={styles.input}
                            placeholder="Votre adresse e-mail"
                            required
                            disabled={isLoading}
                        />
                    </div>

                    {error && <p style={{ color: themeColors.danger, textAlign: 'center', fontWeight: 'bold' }}>{error}</p>}
                    {success && <p style={{ color: themeColors.success, textAlign: 'center', fontWeight: 'bold' }}>{success}</p>}
                    
                    <button type="submit" disabled={isLoading} style={{ ...styles.button, opacity: isLoading ? 0.6 : 1 }}>
                        {isLoading ? 'Envoi en cours...' : 'Envoyer le lien de réinitialisation'}
                    </button>
                </form>

                <p style={{ textAlign: "center", marginTop: 15, color: themeColors.text }}>
                    <Link to="/login" style={styles.link}>Retour à la connexion</Link>
                </p>
            </div>
        </div>
    );
}